import Dexie from 'dexie';

/**
 * IndexedDB-backed storage for the long-lived trust-device token.
 *
 * Why IndexedDB and not localStorage:
 *   - localStorage is synchronous and capped at ~5MB; not a great fit for the
 *     expense outbox we'll add later (Phase B). Sharing one Dexie DB keeps
 *     storage adapters consistent.
 *   - IndexedDB persists across PWA app-restarts and OS-level evictions are
 *     rarer than localStorage's.
 *
 * Singleton pattern — one trust-device row at a time. If user A logs in and
 * then user B uses the same device, the previous row is overwritten. The
 * backend rejects mismatched user-id/token combos, so an old token belonging
 * to a different user just causes a TOTP fallback rather than a security
 * issue.
 */

const db = new Dexie('xenergy-pwa');
// Schema must match offline/outbox.js — both files open the same DB; whichever
// one opens FIRST has to declare every table, otherwise the second open fails
// with a VersionError. Bump version + add tables in BOTH files together.
db.version(2).stores({
  // Singleton — auto-increment id, always cleared before adding so there's
  // only ever one row.
  trustedDevice: '++id',
  // Used by offline/outbox.js, declared here too for schema consistency.
  expenseOutbox: '&clientId, status, createdAt',
});

export async function saveTrustToken(token, fingerprint, expiresAt) {
  await db.trustedDevice.clear();
  await db.trustedDevice.add({ token, fingerprint, expiresAt });
}

export async function getTrustToken() {
  const rows = await db.trustedDevice.toArray();
  return rows[0] ?? null;
}

export async function clearTrustToken() {
  await db.trustedDevice.clear();
}
